

/**
 * Kapselt die Erzeugung zufälliger Werte.
 */
export class RandomUtils {

  /**
   * Erzeugt eine neue zufällige UUID (via `crypto.randomUUID`).
   *
   * @returns Neu erzeugte UUID
   */
  public static uuid(): string {
    return crypto.randomUUID();
  }
}